import { useEffect, useRef } from 'react';
import './ProductRichText.css';

const ACTIONS = [
  { cmd: 'bold', label: 'B', title: 'In đậm' },
  { cmd: 'italic', label: 'I', title: 'In nghiêng' },
  { cmd: 'underline', label: 'U', title: 'Gạch chân' },
  { cmd: 'insertUnorderedList', label: '•', title: 'Danh sách' },
  { cmd: 'insertOrderedList', label: '1.', title: 'Danh sách số' },
];

const ProductRichText = ({ value, onChange }) => {
  const ref = useRef(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    if (document.activeElement === el) return;
    if (el.innerHTML !== (value || '')) {
      el.innerHTML = value || '';
    }
  }, [value]);

  const run = (command) => {
    ref.current?.focus();
    document.execCommand(command, false, null);
    onChange(ref.current?.innerHTML || '');
  };

  const breakLine = () => {
    ref.current?.focus();
    document.execCommand('insertLineBreak');
    onChange(ref.current?.innerHTML || '');
  };

  return (
    <div className="rich-text">
      <div className="rich-text-toolbar">
        {ACTIONS.map((action) => (
          <button
            key={action.cmd}
            type="button"
            title={action.title}
            className={action.cmd === 'italic' ? 'is-italic' : ''}
            onMouseDown={(e) => e.preventDefault()}
            onClick={() => run(action.cmd)}
          >
            {action.label}
          </button>
        ))}
        <button type="button" title="Xuống dòng" onMouseDown={(e) => e.preventDefault()} onClick={breakLine}>
          Xuống dòng
        </button>
      </div>
      <div
        ref={ref}
        className="rich-text-area"
        contentEditable
        role="textbox"
        aria-multiline="true"
        data-placeholder="Mô tả sản phẩm..."
        onInput={(e) => onChange(e.currentTarget.innerHTML)}
      />
    </div>
  );
};

export default ProductRichText;
